import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap, catchError } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { formField } from "src/app/models/formField";

function sortByOrder(fields: formField[]): formField[] {
    return [...fields].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
import { TemplatesActions } from "./templates.actions";
import { TemplatesStateModel } from "./templates.state.model";
import { TestAnalysisApiService } from 'src/app/services/api/test-analysis-api.service';
import { TestCaseApiService } from "src/app/services/api/test-case-api.service";
import { TestSuiteApiService } from "src/app/services/api/test-suite-api.service";
import { TestSpecificationApiService } from "src/app/services/api/test-specification-api.service";
import { SpecificationCoverageApiService } from "src/app/services/api/specification-coverage-api.service";
import { SoftwareVersionCoverageApiService } from "src/app/services/api/software-version-coverage-api.service";
import { EeseCoverageApiService } from "src/app/services/api/eese-coverage-api.service";

@State<TemplatesStateModel>({
    name: 'Templates',
    defaults: {
      TATemplate: [],
      TASearchTemplate: [],
      TCTemplate: [],
      TCSearchTemplate: [],
      TSTemplate: [],
      TSSearchTemplate: [],
      TSpecTemplate: [],
      TSpecSearchTemplate: [],
      TCoverageTemplate: [],
      TCoverageSearchTemplate: [],
      SwVersionCoverageTemplate: [],
      SwVersionCoverageSearchTemplate: [],
      EeseCoverageTemplate: [],
      EeseCoverageSearchTemplate: []
    },
  })
  @Injectable()
  export class TemplatesState {

    constructor(private testAnalysisApiService: TestAnalysisApiService,
        private testCaseApiService: TestCaseApiService,
        private testSuiteApiService: TestSuiteApiService,
        private testSpecificationApiService: TestSpecificationApiService,
        private testCoverageApiService: SpecificationCoverageApiService,
        private softwareVersionCoverageApiService: SoftwareVersionCoverageApiService,
        private eeseCoverageApiService: EeseCoverageApiService
        ){}

    @Action(TemplatesActions.SetTATemplate)
    SetTATemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        //don't update state if we have already downloaded items
        if (state.TATemplate !== undefined && state.TATemplate.length > 0) return EMPTY;

        return this.testAnalysisApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ TATemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TATemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTASearchTemplate)
    SetTASearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TASearchTemplate !== undefined && state.TASearchTemplate.length > 0) return EMPTY;

        return this.testAnalysisApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ TASearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TASearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTCTemplate)
    SetTCTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TCTemplate !== undefined && state.TCTemplate.length > 0) return EMPTY;

        return this.testCaseApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ TCTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TCTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTCSearchTemplate)
    SetTCSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TCSearchTemplate !== undefined && state.TCSearchTemplate.length > 0) return EMPTY;

        return this.testCaseApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ TCSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TCSearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTSTemplate)
    SetTSTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TSTemplate !== undefined && state.TSTemplate.length > 0) return EMPTY;

        return this.testSuiteApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ TSTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TSTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTSSearchTemplate)
    SetTSSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TSSearchTemplate !== undefined && state.TSSearchTemplate.length > 0) return EMPTY;

        return this.testSuiteApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ TSSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TSSearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTSpecTemplate)
    SetTSpecTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TSpecTemplate !== undefined && state.TSpecTemplate.length > 0) return EMPTY;

        return this.testSpecificationApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ TSpecTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TSpecTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTSpecSearchTemplate)
    SetTSpecSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TSpecSearchTemplate !== undefined && state.TSpecSearchTemplate.length > 0) return EMPTY;

        return this.testSpecificationApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ TSpecSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TSpecSearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTCoverageTemplate)
    SetTCoverageTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TCoverageTemplate !== undefined && state.TCoverageTemplate.length > 0) return EMPTY;

        return this.testCoverageApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ TCoverageTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TCoverageTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetTCoverageSearchTemplate)
    SetTCoverageSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.TCoverageSearchTemplate !== undefined && state.TCoverageSearchTemplate.length > 0) return EMPTY;

        return this.testCoverageApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ TCoverageSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load TCoverageSearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetSwVersionCoverageTemplate)
    SetSwVersionCoverageTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.SwVersionCoverageTemplate !== undefined && state.SwVersionCoverageTemplate.length > 0) return EMPTY;

        return this.softwareVersionCoverageApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ SwVersionCoverageTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load SwVersionCoverageTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetSwVersionCoverageSearchTemplate)
    SetSwVersionCoverageSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.SwVersionCoverageSearchTemplate !== undefined && state.SwVersionCoverageSearchTemplate.length > 0) return EMPTY;

        return this.softwareVersionCoverageApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ SwVersionCoverageSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load SwVersionCoverageSearchTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetEeseCoverageTemplate)
    SetEeseCoverageTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.EeseCoverageTemplate !== undefined && state.EeseCoverageTemplate.length > 0) return EMPTY;

        return this.eeseCoverageApiService.getUiTemplate().pipe(
            tap(template => ctx.patchState({ EeseCoverageTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load EeseCoverageTemplate', err); return EMPTY; })
        );
    }

    @Action(TemplatesActions.SetEeseCoverageSearchTemplate)
    SetEeseCoverageSearchTemplate(ctx: StateContext<TemplatesStateModel>) {
        const state = ctx.getState();
        if (state.EeseCoverageSearchTemplate !== undefined && state.EeseCoverageSearchTemplate.length > 0) return EMPTY;

        return this.eeseCoverageApiService.getSearchUiTemplate().pipe(
            tap(template => ctx.patchState({ EeseCoverageSearchTemplate: sortByOrder(template) })),
            catchError((err) => { console.error('Failed to load EeseCoverageSearchTemplate', err); return EMPTY; })
        );
    }

    @Selector()
    static getTATemplate(state: TemplatesStateModel) {
        return state.TATemplate;
    }
    @Selector()
    static getTASearchTemplate(state: TemplatesStateModel) {
        return state.TASearchTemplate;
    }
    @Selector()
    static getTCTemplate(state: TemplatesStateModel) {
        return state.TCTemplate;
    }
    @Selector()
    static getTCSearchTemplate(state: TemplatesStateModel) {
        return state.TCSearchTemplate;
    }
    @Selector()
    static getTSTemplate(state: TemplatesStateModel) {
        return state.TSTemplate;
    }
    @Selector()
    static getTSSearchTemplate(state: TemplatesStateModel) {
        return state.TSSearchTemplate;
    }
    @Selector()
    static getTSpecTemplate(state: TemplatesStateModel) {
        return state.TSpecTemplate;
    }
    @Selector()
    static getTSpecSearchTemplate(state: TemplatesStateModel) {
        return state.TSpecSearchTemplate;
    }
    @Selector()
    static getTCoverageTemplate(state: TemplatesStateModel) {
        return state.TCoverageTemplate;
    }
    @Selector()
    static getTCoverageSearchTemplate(state: TemplatesStateModel) {
        return state.TCoverageSearchTemplate;
    }

    @Selector()
    static getSwVersionCoverageTemplate(state: TemplatesStateModel) {
        return state.SwVersionCoverageTemplate;
    }
    @Selector()
    static getSwVersionCoverageSearchTemplate(state: TemplatesStateModel) {
        return state.SwVersionCoverageSearchTemplate;
    }
    @Selector()
    static getEeseCoverageTemplate(state: TemplatesStateModel) {
        return state.EeseCoverageTemplate;
    }
    @Selector()
    static getEeseCoverageSearchTemplate(state: TemplatesStateModel) {
        return state.EeseCoverageSearchTemplate;
    }
   }